import { z } from "zod";

export const ISSUE_SEMANTIC_SOURCE = {
  AGENT: "agent",
  UNCLASSIFIED: "unclassified",
} as const;
export const ISSUE_SEMANTIC_SOURCES = Object.values(ISSUE_SEMANTIC_SOURCE);
export const IssueSemanticSourceSchema = z.enum(ISSUE_SEMANTIC_SOURCES);
export type IssueSemanticSource = z.infer<typeof IssueSemanticSourceSchema>;

export const ISSUE_SEMANTIC_FACT_KIND = {
  ACCESS_GATE: "access_gate",
  ARCHITECTURE: "architecture",
  HEADING: "heading",
  JOURNEY: "journey",
  ORIGIN_CONDITION: "origin_condition",
  WORDING: "wording",
} as const;
export const ISSUE_SEMANTIC_FACT_KINDS = Object.values(
  ISSUE_SEMANTIC_FACT_KIND,
);
export const IssueSemanticFactKindSchema = z.enum(ISSUE_SEMANTIC_FACT_KINDS);
export type IssueSemanticFactKind = z.infer<typeof IssueSemanticFactKindSchema>;

export const HEADING_DEFECT = {
  EMPTY: "empty",
  MULTIPLE_PRIMARY: "multiple_primary",
  PRESENTATIONAL: "presentational",
  SKIPPED_LEVELS: "skipped_levels",
} as const;
export const HEADING_DEFECTS = Object.values(HEADING_DEFECT);
export const HeadingDefectSchema = z.enum(HEADING_DEFECTS);
export type HeadingDefect = z.infer<typeof HeadingDefectSchema>;

export const ACCESS_CONTROL = {
  AGE_VERIFICATION: "age_verification",
  COOKIE_CONSENT: "cookie_consent",
  COUNTRY_SELECTION: "country_selection",
} as const;
export const ACCESS_CONTROLS = Object.values(ACCESS_CONTROL);
export const AccessControlSchema = z.enum(ACCESS_CONTROLS);
export type AccessControl = z.infer<typeof AccessControlSchema>;

export const JOURNEY_RELEVANCE = {
  GENERAL: "general",
  ONWARD_STEP: "onward_step",
} as const;
export const JOURNEY_RELEVANCES = Object.values(JOURNEY_RELEVANCE);
export const JourneyRelevanceSchema = z.enum(JOURNEY_RELEVANCES);
export type JourneyRelevance = z.infer<typeof JourneyRelevanceSchema>;

export const ORIGIN_CONDITION = {
  AI_CRAWLER_BLOCK: "ai_crawler_block",
  MISSING_RESOURCE: "missing_resource",
} as const;
export const ORIGIN_CONDITIONS = Object.values(ORIGIN_CONDITION);
export const OriginConditionSchema = z.enum(ORIGIN_CONDITIONS);
export type OriginCondition = z.infer<typeof OriginConditionSchema>;

export const ARCHITECTURE_SIGNAL = {
  DESTINATION_RELATIONSHIP: "destination_relationship",
  NON_ARCHITECTURAL: "non_architectural",
  ORGANIZING: "organizing",
  OVERLAP: "overlap",
  PATTERN: "pattern",
  REORGANIZE: "reorganize",
} as const;
export const ARCHITECTURE_SIGNALS = Object.values(ARCHITECTURE_SIGNAL);
export const ArchitectureSignalSchema = z.enum(ARCHITECTURE_SIGNALS);
export type ArchitectureSignal = z.infer<typeof ArchitectureSignalSchema>;

export const WORDING_CONTEXT = {
  COMPARISON_TABLE: "comparison_table",
  GENERAL: "general",
} as const;
export const WORDING_CONTEXTS = Object.values(WORDING_CONTEXT);
export const WordingContextSchema = z.enum(WORDING_CONTEXTS);
export type WordingContext = z.infer<typeof WordingContextSchema>;
